import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJoinedWithoutProctor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6182 4.66663H4.11816C3.72034 4.66663 3.33881 4.82466 3.0575 5.10597C2.7762 5.38727 2.61816 5.7688 2.61816 6.16663V19.6666C2.61816 20.0645 2.7762 20.446 3.0575 20.7273C3.33881 21.0086 3.72034 21.1666 4.11816 21.1666H20.6182C21.016 21.1666 21.3975 21.0086 21.6788 20.7273C21.9601 20.446 22.1182 20.0645 22.1182 19.6666V6.16663C22.1182 5.7688 21.9601 5.38727 21.6788 5.10597C21.3975 4.82466 21.016 4.66663 20.6182 4.66663ZM9.36816 12.1666C9.36816 11.5733 9.54411 10.9933 9.87376 10.4999C10.2034 10.0066 10.6719 9.62205 11.2201 9.39499C11.7683 9.16792 12.3715 9.10851 12.9534 9.22427C13.5354 9.34003 14.0699 9.62575 14.4895 10.0453C14.909 10.4649 15.1948 10.9994 15.3105 11.5814C15.4263 12.1633 15.3669 12.7665 15.1398 13.3147C14.9127 13.8629 14.5282 14.3314 14.0349 14.661C13.5415 14.9907 12.9615 15.1666 12.3682 15.1666C11.5725 15.1666 10.8095 14.8506 10.2468 14.2879C9.68423 13.7253 9.36816 12.9623 9.36816 12.1666ZM7.1716 19.6666C7.69816 18.7543 8.45561 17.9967 9.36781 17.47C10.28 16.9432 11.3148 16.6659 12.3682 16.6659C13.4215 16.6659 14.4563 16.9432 15.3685 17.47C16.2807 17.9967 17.0382 18.7543 17.5647 19.6666H7.1716ZM20.6182 19.6666H19.2429C18.4512 17.8587 16.9799 16.4348 15.1469 15.7029C15.8831 15.1249 16.4208 14.3317 16.6851 13.4338C16.9493 12.5359 16.927 11.5779 16.6213 10.6933C16.3155 9.80864 15.7415 9.04135 14.9792 8.49826C14.2169 7.95517 13.3042 7.66331 12.3682 7.66331C11.4322 7.66331 10.5195 7.95517 9.75714 8.49826C8.99481 9.04135 8.42081 9.80864 8.11504 10.6933C7.80928 11.5779 7.78698 12.5359 8.05124 13.4338C8.31551 14.3317 8.85319 15.1249 9.58941 15.7029C7.75646 16.4348 6.28515 17.8587 5.49348 19.6666H4.11816V6.16663H20.6182V19.6666Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_15437_29564)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.4263 19.6235C20.505 19.6473 20.5782 19.6864 20.6418 19.7385C20.7054 19.7906 20.758 19.8547 20.7967 19.9272C20.8354 19.9997 20.8595 20.0791 20.8675 20.1609C20.8754 20.2427 20.8672 20.3253 20.8432 20.404C20.8193 20.4827 20.78 20.5559 20.7278 20.6195C20.6755 20.683 20.6112 20.7357 20.5386 20.7745C20.466 20.8133 20.3864 20.8374 20.3045 20.8455C20.2226 20.8537 20.1399 20.8456 20.0612 20.8217L4.11057 6.52777C3.95158 6.47966 3.81833 6.3704 3.74014 6.22403C3.66195 6.07765 3.64521 5.90615 3.69363 5.74725C3.74204 5.58835 3.85162 5.45507 3.99828 5.37673C4.14494 5.29838 4.31665 5.2814 4.47564 5.3295L20.4263 19.6235Z",
				fill: "black"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_15437_29564",
			x: 3.16602,
			y: 4.80261,
			width: 18.2041,
			height: 16.546,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .25 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_15437_29564"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_15437_29564",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgJoinedWithoutProctor;
